<template>
    <v-container fluid class="grey lighten-5 fill-height pa-0 mb-0">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-row justify="center">
            <v-col cols="12" xl="12" class="pa-0 ma-0">
                <div class="d-flex align-center mb-2 bsp_header pa-2">
                    <v-icon dark size="38" class="ma-4">add_reaction</v-icon>
                    <div>
                        <h1 class="text-h4 font-weight-white text-uppercase tracking-tight">
                            Ficha de Postulante
                        </h1>
                    </div>
                </div>
                <v-form ref="refMain" lazy-validation>
                    <v-row class="px-2">            
                        <v-col cols="12" md="6" class="pl-4 pt-0">
                            <v-card class="pa-3 pb-0 rounded-xl elevation-2" filled>
                                <div class="text-subtitle-1 font-weight-bold mb-6 primary--text d-flex align-center">
                                    <v-icon color="primary" left>assignment_ind</v-icon>
                                    Datos Personales
                                </div>                            
                                <v-row dense>
                                    <v-col cols="12" sm="5">
                                        <v-select label="* Tipo Documento" filled dense v-model="dPriAlumno.tipo_documento" :items="[{text: 'DNI', value: 1},{text: 'Carnet Extranjeria', value: 2}]" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="7">
                                        <v-form ref="refDni">
                                            <v-text-field ref="refNro" v-model="dPriAlumno.DNI" label="* Numero" prepend-inner-icon="credit_card" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= cNroDocSizeMax) || 'El campo debe ser <= a '+cNroDocSizeMax+' caracteres.']" :maxlength="cNroDocSizeMax" type="number" filled dense counter></v-text-field>
                                        </v-form>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="dPriAlumno.ApPaterno" label="* Apellido Paterno" @input="dPriAlumno.ApPaterno = $event.toUpperCase()" prepend-inner-icon="person" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 40 caracteres.']" :maxlength="40" autocomplete="off" filled dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="dPriAlumno.ApMaterno" label="* Apellido Materno" @input="dPriAlumno.ApMaterno = $event.toUpperCase()" prepend-inner-icon="person" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 40 caracteres.']" :maxlength="40" autocomplete="off" filled dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="4">
                                        <v-text-field v-model="dPriAlumno.Nombres" label="* Nombres" @input="dPriAlumno.Nombres = $event.toUpperCase()" prepend-inner-icon="person" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 40 caracteres.']" :maxlength="40" autocomplete="off" filled dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-select v-model="dPriAlumno.Sexo" label="* Sexo" :items="[{text: 'Femenino', value: 'F'},{text: 'Masculino', value: 'M'}]" prepend-inner-icon="transgender" :rules="[v => !!v || 'El campo es requerido']" filled dense></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-menu
                                            v-model="dFechaMenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                v-model="dFecha"
                                                label="F. Nacimiento"
                                                prepend-inner-icon="event"
                                                readonly
                                                filled dense
                                                v-bind="attrs"
                                                v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="dFecha"
                                                :max="cFNacimientoMax"
                                                @input="dFechaMenu = false"
                                                no-title
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-select v-model="dPriAlumno.EstadoCivil" label="* Estado Civil" :items="['CASADO','DIVORCIADO','SOLTERO','VIUDO']" prepend-inner-icon="wc" :rules="[v => !!v || 'El campo es requerido']" filled dense></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-text-field v-model="dPriAlumno.hijos" label="* Nro de hijos" prepend-inner-icon="child_care" maxlength="1" type="number" filled dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="8">
                                        <v-text-field v-model="dPriAlumno.Direccion" label="Dirección - Referencia" prepend-inner-icon="location_on" :maxlength="80" autocomplete="off" filled dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-select v-model="dPriAlumno.TipoVivienda" label="* Tipo Vivienda" :items="['Propia','Alquilada','Familiar','Otros']" prepend-inner-icon="home_work" :rules="[v => !!v || 'El campo es requerido']" filled dense></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete
                                            v-model="dPriAlumno.UbigeoD" label="Ubigeo de Referencia (Depa/Prov/Dist)"
                                            :items=dUbigeos
                                            filled dense clearable prepend-inner-icon="location_on">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete
                                            v-model="dPriAlumno.UbigeoN" label="Ubigeo de Origen (Depa/Prov/Dist)"
                                            :items=dUbigeos
                                            filled dense prepend-inner-icon="location_on">
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-card class="pa-3 mt-3 pb-0 rounded-xl elevation-2" filled>
                                <div class="text-subtitle-1 font-weight-bold mb-6 primary--text d-flex align-center">
                                    <v-icon color="primary" left>contact_phone</v-icon> Contacto
                                </div>
                                <v-row dense>
                                    <v-col cols="12" sm="3">
                                        <v-text-field v-model="dPriAlumno.Celular" label="* Celular 1" filled dense prepend-inner-icon="smartphone" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 9) || 'El campo debe ser menor de 9 caracteres.']" :maxlength="9" autocomplete="off"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-text-field v-model="dPriAlumno.Telefono" label="Celular 2" filled dense prepend-inner-icon="phone" :maxlength="10" autocomplete="off"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="dPriAlumno.Email" label="Correo Electrónico" filled dense prepend-inner-icon="email" :maxlength="100" autocomplete="off"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="dPriAlumno.NombreApoderado" label="* Apoderado nombre" :rules="[v => !!v || 'El campo es requerido']" filled dense prepend-inner-icon="escalator_warning" :maxlength="50" autocomplete="off"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="dPriAlumno.TelefonoApoderado" label="* Apoderado Celular" :rules="[v => !!v || 'El campo es requerido']" filled dense prepend-inner-icon="phone" :maxlength="10" autocomplete="off"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="pr-4 pt-0">
                            <v-card class="pa-3 pb-0 rounded-xl elevation-2" filled>
                                <div class="text-subtitle-1 font-weight-bold mb-6 primary--text d-flex align-center">
                                    <v-icon color="primary" left>school</v-icon> Datos Académicos
                                </div>
                                <v-row dense>
                                    <v-col cols="12" sm="8">
                                        <v-autocomplete v-model="dPriAlumno.IdServicio" label="* Carrera Profesional"
                                                            :items="ssPriServiciosIngreso" item-value="IdServicio" item-text="Descripcion2"
                                                            filled dense prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-autocomplete
                                            v-model="dPriAlumno.IdModalidadAdmision" :items="dAdmModalidad"  item-value="idmodalidad" item-text="nombre"
                                            label="* Modalidad Admisión" filled dense prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-select v-model="dPriAlumno.QuienEligioCarrera" label="* ¿Quien eligió su profesión?"
                                            :items="['Yo', 'Mis Padres', 'Mis Hermanos', 'Mis Familiares', 'Otros']" filled dense prepend-inner-icon="contact_support" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select v-model="dPriAlumno.motivoEstudio" label="* Principal motivo para estudiar esta carrera"
                                            :items="['Inserción Laboral Rápida','Vocación','Espíritu Emprendedor','Crecimiento Económico','Cambio de Profesión','Especialización','Propósito Social','Otros']" filled dense prepend-inner-icon="contact_support" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-select>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="8">
                                        <v-dialog v-model="dPriColegioModalDialog" persistent max-width="900px">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-bind="attrs" v-on="on" @click:append="dPriColegioModalDialog = true"
                                                    v-model="dPriColegioText" label="* Colegio"
                                                    readonly filled dense prepend-inner-icon="home" append-icon="search" :rules="[v => !!v || 'El campo es requerido']"
                                                ></v-text-field>
                                            </template>
                                            <v-card>
                                                <v-card-title style="background-color:#455A64">
                                                    <v-form ref="refPriColegio">
                                                        <v-row fluid>
                                                            <v-col cols="12" sm="6" md="6" lg="6" class="pa-0">
                                                                <v-text-field v-model="dPriColegio.Nombre" label="* Colegio" prepend-inner-icon="home" filled dense clearable :rules="[v => !!v || 'El campo es requerido']" autocomplete="off" dark></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="5" md="4" lg="4" class="pa-0">
                                                                <v-select v-model="dPriColegio.Dpto" label="* Departamento" :items="dPriColegioDepartamento" filled dense prepend-inner-icon="location_on" :rules="[v => !!v || 'El campo es requerido']" dark></v-select>
                                                            </v-col>
                                                            <v-col cols="12" sm="1" md="2" lg="2" class="pa-0">
                                                                <v-btn @click.prevent="fuPriColegioSearch" :loading="dPriColegioLoading" color="blue-grey" dark x-large><v-icon>search</v-icon></v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-form>
                                                </v-card-title>
                                                <v-data-table
                                                    v-model="dPriColegioTable.selected"
                                                    :headers="dPriColegioTable.headers"
                                                    :items="dPriColegios"
                                                    :loading="dPriColegioLoading"
                                                    single-select
                                                    item-key="IdColegio"
                                                    show-select
                                                    class="elevation-1">
                                                    <template v-slot:[`item.Dpto`]="{ item }">
                                                        <v-chip color="success" dark>{{item.Dpto+"/"+item.Provincia+"/"+item.Distrito}}</v-chip>
                                                    </template>
                                                </v-data-table>
                                                <v-card-actions class="blue-grey darken-2">
                                                    <v-btn @click="fuPriColegioSelected()" color="green" dark><v-icon>check</v-icon> Seleccionar</v-btn>
                                                    <v-spacer></v-spacer>
                                                    <v-btn @click="dPriColegioModalDialog = false" color="grey darken-4" dark><v-icon>close</v-icon> Cerrar</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-autocomplete 
                                            v-model="dPriAlumno.AnioEgresoSecundaria" :items="dYears"
                                            label="* Año egreso colegio" filled dense prepend-inner-icon="event_note" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-card class="pa-3 mt-3 pb-0 rounded-xl elevation-2">
                                <div class="text-subtitle-1 font-weight-bold mb-6 primary--text d-flex align-center">
                                    <v-icon color="primary" left>attach_money</v-icon> Datos Socioeconómicos
                                </div>
                                <v-row dense>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-autocomplete v-model="dPriAlumno.DependeEco" label="Dependencia Económica"
                                            :items="['Padre', 'Madre', 'Hermano', 'Conyuge', 'Independiente', 'Otros']"
                                            filled dense prepend-inner-icon="wc" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-select v-model="dPriAlumno.TipoTrabajo" label="Tipo de Trabajo"
                                            :items="['Dependiente', 'Independiente']"
                                            filled dense prepend-inner-icon="business_center" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <v-select v-model="dPriAlumno.IngresoMensual" label="* Ingreso Mensual"
                                            :items="['De 501 a 800', 'De 801 a 1000', 'De 1001 a 1500', 'De 1501 a más']"
                                            filled dense prepend-inner-icon="monetization_on" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-autocomplete v-model="dPriAlumno.Ocupacion" label="* Ocupación"
                                            :items="['Actividad Artesanal',
                                                    'Actividades agrícolas, silvícolas',
                                                    'Actividades ganaderas, de caza y pesca',
                                                    'Administrador',
                                                    'ALBAÑIL / CONSTRUCCION / GASFITERO',
                                                    'ASISTENTE ADMINISTRATIVO / GERENCIA',
                                                    'ATENCION AL CLIENTE / INTERNET',
                                                    'AYUDANTE CASA / ENFERMERIA / NIÑERA',
                                                    'BARMAN / COCINA / MOZO',
                                                    'CAJERO / CAMBISTA / PAGADOR',
                                                    'COMERCIANTE / EMPRESARIO',
                                                    'CONDUCTOR',
                                                    'DISEÑO GRAFICO / WEB',
                                                    'DOCENTE',
                                                    'FF.AA. y PP',
                                                    'HOUSEKEEPING / RECEPCIONISTA / GUIA',
                                                    'INDEPENDIENTE',
                                                    'MUSICO',
                                                    'Obreros',
                                                    'Operadores de maquinaria',
                                                    'OTROS',
                                                    'PROMOTOR / SUPERVISOR / CONTRATISTA',
                                                    'Servicios de protección y vigilancia',
                                                    'Técnico']" filled dense prepend-inner-icon="school" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="dPriAlumno.nroDependientes" label="* Nro personas que dependan del ingreso" prepend-inner-icon="family_restroom" maxlength="1" type="number" filled dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="dPriAlumno.CentroTrabajo" label="* Nombre Centro de Trabajo" :rules="[v => !!v || 'El campo es requerido']" filled dense prepend-inner-icon="apartment" :maxlength="50" autocomplete="off"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="dPriAlumno.DireccionTrabajo" label="* Dirección de Trabajo" :rules="[v => !!v || 'El campo es requerido']" filled dense prepend-inner-icon="location_on" :maxlength="50" autocomplete="off"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-select v-model="dPriAlumno.dispositivoPrincipal" label="* Dispositivo principal"
                                            :items="['Celular', 'Laptop', 'PC', 'Tablet']"
                                            filled dense prepend-inner-icon="devices_other" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-switch v-model="dPriAlumno.internet" label="Acceso a internet en casa" inset dense class="ma-0"></v-switch>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-switch v-model="dPriAlumno.autorizoRecibirInfo" label="Autorizo recibir información comercial" inset dense class="ma-0"></v-switch>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="6">
                                        <v-switch v-model="dPriAlumno.autorizoUsoDatos" label="Autorizo uso de mis datos para fines académicos y administrativos" inset dense class="ma-0"></v-switch>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="6">
                                        <v-switch v-model="dPriAlumno.autorizoUsoImagen" label="Autorizo uso de mi imagen para fines académicos y publicitarios" inset dense class="ma-0"></v-switch>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <div class="d-flex justify-end mt-2">
                                <v-btn @click.prevent="fuAlumnoSave" :loading="dLoading" color="primary" class="px-12 text-none" elevation="6" large>
                                    <v-icon left>save</v-icon> Registrar Postulante
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { dUbigeos } from '@/helpers/ubigeos.js';
import {fuServicioInicialColor} from '@/helpers/index.js';

export default {
    name: 'Postulante',
    mounted(){
        if (typeof this.$route.params.pIdVisitas != "undefined"){
            this.fuLoad(this.$route.params.pIdVisitas);
        }
        let today = new Date();
        for (var i = today.getFullYear(); i >= today.getFullYear()-70; i--) {
            this.dYears.push(i);
        }
        if(this.ssUser) this.dPriAlumno.operador=this.ssUser.Usuario
    },
    data: () => ({
        dYears: [],
        dFechaMenu: false,
        dFecha: '',
        dLoading: false,
        dUbigeos: dUbigeos,
        dSnackbar: false,
        dAdmModalidad: [],
        dPriAlumnos: [],
        dPriAlumno: {
            DNI: '',
            ApPaterno: '',
            ApMaterno: '',
            Nombres: '',
            Sexo: 'F',
            FechaNac: '',
            Direccion: '',
            Telefono: '',
            Codigo: '',
            Condicion: 'P',
            IdServicio: '',
            Email: '',
            IdColegio: '',
            FechaInscripcion: '',
            TurnoAdmision: 'M',
            IdModalidadAdmision: '14',
            operador: 'web',
            CodigoAlterno: '',
            FechaCreacion: '',
            IdVisita: '',
            ModalidadAdmision: 'P',
            EstadoCivil: '',
            TipoVivienda: '',
            nroDependientes: 0,
        DependeEco: 'Padre',
        TipoTrabajo: 'Dependiente',
        CentroTrabajo: '',
        DireccionTrabajo: '',
        IngresoMensual: '',
        Ocupacion: '',
        QuienEligioCarrera: '',
            NombreApoderado: '',
            TelefonoApoderado: '',
            internet: 1,
            dispositivoPrincipal: '',
            FecIns: '',
            motivoEstudio: '',
            hijos: 0,
            IdPeriodoAdmision: '',
            autorizoRecibirInfo: 1,
            Celular: '',
            autorizoUsoDatos: 1,
            autorizoUsoImagen: 1,
            UbigeoD: '',
            UbigeoN: '',
            tipo_documento: '',
            AnioEgresoSecundaria: ''
        },
        dPriColegio: {
            Nombre:'',
            Dpto: 'Cusco'
        },
        dPriColegios: [],
        dPriColegioLoading: false,
        dPriColegioModalDialog: false,
        dPriColegioTable: {
            headers: [
                {value: 'IdColegio', text: 'Codigo'},
                {value: 'Nombre', text: 'Nombre'},
                {value: 'Modalidad', text: 'Modalidad'},
                {value: 'TipoColegio', text: 'Tipo'},
                {value: 'Dpto', text: 'Ubigeo'}
            ],
            selected: []
        },
        dPriColegioText: '',
        dPriColegioDepartamento: [
            'Amazonas',
            'Ancash',
            'Apurimac',
            'Arequipa',
            'Ayacucho',
            'Cajamarca',
            'Callao',
            'Cusco',
            'Huancavelica',
            'Huanuco',
            'Ica',
            'Junin',
            'La Libertad',
            'Lambayeque',
            'Lima',
            'Loreto',
            'Madre de Dios',
            'Moquegua',
            'Otros',
            'Pasco',
            'Piura',
            'Puno',
            'San Martin',
            'Tacna',
            'Tumbes',
            'Ucayali',
        ],
    }),
    watch: {
        dFecha(val) {
            if (val) {
                this.dPriAlumno.FechaNac = val.split("-").join("");
            }
        },
    },
    computed: {
        ...mapState(['ssUser', 'ssPriServiciosIngreso']),
        cFNacimientoMax () {
            return moment().subtract(15,'years').format("YYYY-MM-DD");
        },
        cNroDocSizeMax () {
            if (this.dPriAlumno.tipo_documento == 1)
                return 8
            else
                return 12
        },
    },
    methods: {
        async fuLoad(pIdVisitas) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query admvisita($idVisitas: ID!){
                        admvisita(idVisitas:$idVisitas){
                            idVisitas
                            AP
                            AM
                            Nombres
                            Telefono
                            Email
                            IdServicio
                            Turno
                            Celular
                            Direccion
                            IdPeriodoAdmision
                            Dni
                            vSexo
                            FecNac
                            IdUbigeo
                            IdUbigeoOrigen
                            tipo_documento
                            estadoCivil
                        }
                        admmodalidadByactivo(activo:1){
                            idmodalidad
                            nombre
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        idVisitas: pIdVisitas
                    }
                })
                this.dAdmModalidad = response.data.admmodalidadByactivo.sort((p1, p2) => (p1.nombre < p2.nombre) ? -1 : (p1.nombre > p2.nombre) ? 1 : 0);
                if(response.data.admvisita.Dni) this.dPriAlumno.DNI = response.data.admvisita.Dni;
                this.dPriAlumno.ApPaterno = response.data.admvisita.AP;
                this.dPriAlumno.ApMaterno = response.data.admvisita.AM;
                this.dPriAlumno.Nombres = response.data.admvisita.Nombres;
                this.dPriAlumno.Sexo = response.data.admvisita.vSexo;
                if(response.data.admvisita.FecNac) this.dFecha = response.data.admvisita.FecNac.substring(0,10);
                this.dPriAlumno.Direccion = response.data.admvisita.Direccion;
                this.dPriAlumno.Telefono = response.data.admvisita.Telefono;
                this.dPriAlumno.IdServicio = response.data.admvisita.IdServicio;
                this.dPriAlumno.Email = response.data.admvisita.Email;
                this.dPriAlumno.TurnoAdmision = response.data.admvisita.Turno.substring(0,1);
                this.dPriAlumno.IdVisita = response.data.admvisita.idVisitas;
                this.dPriAlumno.IdPeriodoAdmision = response.data.admvisita.IdPeriodoAdmision;
                this.dPriAlumno.Celular = response.data.admvisita.Celular;
                this.dPriAlumno.UbigeoD = response.data.admvisita.IdUbigeo;
                this.dPriAlumno.UbigeoN = response.data.admvisita.IdUbigeoOrigen;
                this.dPriAlumno.tipo_documento = response.data.admvisita.tipo_documento;
                this.dPriAlumno.EstadoCivil = response.data.admvisita.estadoCivil;
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading = false;
                this.fuprialumnoCreateValidate();
            }
        },
        async fuprialumnoCreateValidate() {
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoCreateValidate($DNI: String!, $IdServicio: Int!){
                        prialumnoCreateValidate(DNI:$DNI, IdServicio:$IdServicio){
                            message
		                    data
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        DNI: this.dPriAlumno.DNI,
                        IdServicio: this.dPriAlumno.IdServicio,
                    }
                })
                if(response.data.prialumnoCreateValidate.length>0){
                    const mensajeConcatenado = response.data.prialumnoCreateValidate.map(e => e.message).join('<br>');
                    Swal.fire({
                        icon: 'warning',
                        title: '¡ Advertencia !',
                        html: mensajeConcatenado
                    })
                }
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        fuPriColegioSearch(){
            if(!this.$refs.refPriColegio.validate()){
                this.dSnackbar = true;
            } else {
                this.fuPricolegioByNombreByDpto();                
            }
        },
        fuPriColegioSelected(){
            if(!this.dPriColegioTable.selected){
                Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
            } else {
                if(this.dPriColegioTable.selected.length==0)
                    Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
                else{
                    this.dPriAlumno.IdColegio = this.dPriColegioTable.selected[0].IdColegio;
                    this.dPriColegioText = this.dPriColegioTable.selected[0].IdColegio + " - " + this.dPriColegioTable.selected[0].Nombre + " - " + this.dPriColegioTable.selected[0].Dpto+ "/" + this.dPriColegioTable.selected[0].Provincia+ "/" + this.dPriColegioTable.selected[0].Distrito;
                    this.dPriColegioModalDialog = false;
                }
            }
        },
        async fuPricolegioByNombreByDpto () {
            try {
                this.dPriColegioLoading = true;
                const response = await this.$apollo.query({
                    query: gql`query pricolegioByNombreByDpto($Nombre: String!, $Dpto: String!){
                        pricolegioByNombreByDpto(Nombre: $Nombre, Dpto: $Dpto){
                            IdColegio
                            Nombre
                            Modalidad
                            TipoColegio
                            Dpto
                            Distrito
                            Provincia
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        Nombre: this.dPriColegio.Nombre,
                        Dpto: this.dPriColegio.Dpto,
                    }
                })
                this.dPriColegios = response.data.pricolegioByNombreByDpto;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error')
            } finally {
                this.dPriColegioLoading = false;
            }
        },
        fuAlumnoSave () {
            if(!this.$refs.refMain.validate()){
                this.dSnackbar = true;
            } else {
                this.dPriAlumno.FechaInscripcion = this.dPriAlumno.FechaCreacion = this.dPriAlumno.FecIns = moment().format("YYYYMMDD HH:mm:ss");
                this.fuAlumnoCreate();
            }
        },
        async fuAlumnoCreate () {
            try {
                this.dIsUpdating = true;
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnoCreate($input: prialumnoCreateInput!){
                        prialumnoCreate(input: $input){
                            IdAlumno
                            ApPaterno
                            ApMaterno
                            Nombres
                            Codigo
                            IdServicio
                            priservicio{
                                Descripcion
                            }
                        }
                    }`,
                    variables: {
                        input: this.dPriAlumno
                    }
                });
                if(response.data){
                    Swal.fire({
                        icon: 'success',
                        title: 'Felicitaciones',
                        html: 'Se registró como Postulante.<br>' +
                            '<b>¿Desea continuar y registrar la matricula?</b>',
                        showCancelButton: true,
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Si, deseo matricular',
                        cancelButtonText: 'No',
                        allowOutsideClick: false,
                        showLoaderOnConfirm: true,
                    }).then((result) => {
                        if (result.value){
                            this.$router.push(`/AlumnoItem/${response.data.prialumnoCreate.IdAlumno}`);
                        }
                        else
                            this.$router.push(`/VisitanteAdd`);
                    })
                } else {
                    Swal.fire({
                            icon: 'error',
                            title: '¡ ERROR !',
                            html: 'No se guardó.<br>' +
                                'Intente de nuevo o comuníquese con el AREA DE VENTAS.'
                        })
                }
            } catch (error) {
                console.log(error);
                Swal.fire({
                            icon: 'error',
                            title: '¡ ERROR !',
                            html: 'No se guardó.<br>' +
                                'Intente de nuevo o comuníquese con el AREA DE VENTAS.'
                        })
            } finally {
                this.dIsUpdating = false;
            }
        },
    }
}
</script>
<style scoped>
    .bsp_header {
        background: linear-gradient(130deg, transparent 0% 87%, rgba(255, 255, 255, .6) 87.1% 100%),
                    linear-gradient(130deg, transparent 0% 75%, rgba(255, 255, 255, .4) 75.1% 100%),
                    linear-gradient(90deg, transparent 0% 35%, rgba(255, 255, 255, .3) 65.1% 100%),
                    linear-gradient(130deg, transparent 0% 60%, rgba(255, 255, 255, .2) 60.1% 100%),
                    linear-gradient(90deg, #3498db 0%, #2980b9 100%); /* Color base reemplazando var(--headerPrimary) */
        color: white;
    }
</style>